import React from "react";

const ProductContent = (props) => {
  const { image, title, description, total, explanation } = props;
  return (
    <>
      <img className="my-2 w-12 h-12" src={image} alt="imageproduct" />
      <div className="flex justify-between h-full flex-col">
        <div className="text-light-blue text-base text-center font-bold">{title}</div>
        <div className="text-light-gray text-sm font-bold text-center">{description}</div>
        <div className="font-bold text-center text-s text-light-black">
          {total} <span className="text-s">{explanation}</span>{" "}
        </div>
      </div>
    </>
  );
};

export default ProductContent;
